export const REASSIGN_PRODUCER = "REASSIGN_PRODUCER";
export const GET_PRODUCER_LIST = "GET_PRODUCER_LIST";
export const RESET_DATA_PRODUCT_DETAIL = "RESET_DATA_PRODUCT_DETAIL";
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const DETAILS = 'DETAILS';
export const PEOPLESECTIONDATA = 'PEOPLESECTIONDATA';
export const COLLATERALDATA = 'COLLATERALDATA';
export const RELATEDASSETS = 'RELATEDASSETS';
export const SET_DETAILPAGE_RESULT = 'SET_DETAILPAGE_RESULT';
export const RESET_DATA_ISLOADING = 'RESET_DATA_ISLOADING';
export const RESET_ADDITIONAL_DETAILS = 'RESET_ADDITIONAL_DETAILS';

export const CLIENT_DETAILS = 'CLIENT_DETAILS';
export const CLIENT_PEOPLESECTIONDATA = 'CLIENT_PEOPLESECTIONDATA';
export const CLIENT_COLLATERALDATA = 'CLIENT_COLLATERALDATA';
export const CLIENT_RELATEDASSETS = 'CLIENT_RELATEDASSETS';
export const SET_CLIENT_DETAILPAGE_RESULT = 'SET_CLIENT_DETAILPAGE_RESULT';
export const RESET_CLIENT_ISLOADING = 'RESET_CLIENT_ISLOADING';
export const CLIENT_RESET_ADDITIONAL_DETAILS = 'CLIENT_RESET_ADDITIONAL_DETAILS';
export const CLIENT_ATTESTATION_INFO = 'CLIENT_ATTESTATION_INFO';
export const CLIENT_ATTESTATION_RESULT = 'CLIENT_ATTESTATION_RESULT';

export const LOADER = 'LOADER';
export const GLOSSARYDATA = 'GLOSSARYDATA';
export const WHATSNEWDATA = 'WHATSNEWDATA';
export const NEWJOINERDATA = 'NEWJOINERDATA';
export const GET_TOPIC_COLLECTION = 'GET_TOPIC_COLLECTION';
export const GET_POPULAR_COLLECTION = 'GET_POPULAR_COLLECTION';
export const GET_RECENTLY_VIEW_COLLECTION = 'GET_RECENTLY_VIEW_COLLECTION';
export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
export const STACK_SEARCH_RESULTS = 'STACK_SEARCH_RESULTS';
export const SEARCH_LOADER = 'SEARCH_LOADER';
export const SAVE_HISTORY_STATE = 'SAVE_HISTORY_STATE';
export const RESET_SEARCH_RESULT = 'RESET_SEARCH_RESULT';
export const GET_CONFIGURATION_DATA = 'GET_CONFIGURATION_DATA';
export const GET_TERM_STORE = 'GET_TERM_STORE';
export const PROFILE_PHOTO = 'PROFILE_PHOTO';
export const SEARCH_BASED_REFINERS = 'SEARCH_BASED_REFINERS';
export const PAGE_LEVEL_REFINER = 'PAGE_LEVEL_REFINER';
export const GET_SEARCH_RESULT_REFINER_DATA = 'GET_SEARCH_RESULT_REFINER_DATA';
export const HOME_SECTIONS_LOADER = 'HOME_SECTIONS_LOADER';
export const RESET_HOME_SEARCH_RESULT = 'RESET_HOME_SEARCH_RESULT';
export const GET_TOPIC_DATA = 'GET_TOPIC_DATA';
export const CART_COMPARE_DATA = 'CART_COMPARE_DATA';
export const CART_OPEN = 'CART_OPEN';
export const GET_SEARCH_SUGGESTIONS = 'GET_SEARCH_SUGGESTIONS';
export const GET_TOGGLE_DATA = 'GET_TOGGLE_DATA';
export const GET_CONTACT_COLLECTION = 'GET_CONTACT_COLLECTION';
export const GET_CLIENT_CONTACT_COLLECTION = 'GET_CLIENT_CONTACT_COLLECTION';
export const ADD_SELECTED_ASSETS_PILLS_COLLECTION = 'ADD_SELECTED_ASSETS_PILLS_COLLECTION';
export const GET_API_RESPONSE_STATUS = 'GET_API_RESPONSE_STATUS';
export const ADD_MYDATA_TILE = 'ADD_MYDATA_TILE';
export const REMOVE_MYDATA_TILE = 'REMOVE_MYDATA_TILE';
export const GET_REQUESTACCESS_COLLECTION = 'GET_REQUESTACCESS_COLLECTION';
export const RESET_REQUESTACCESS_COLLECTION = 'RESET_REQUESTACCESS_COLLECTION';
export const SET_CLIENT_DATA_TOGGLE = 'SET_CLIENT_DATA_TOGGLE';
export const SAVE_NEW_DATA_PRODUCT = 'SAVE_NEW_DATA_PRODUCT';
export const SET_CLEAR_SEARCH_TEXT = 'SET_CLEAR_SEARCH_TEXT';
export const SET_CLEAR_REFINERS = 'SET_CLEAR_REFINERS';
export const SET_CLEAR_SEARCH_REFINERS = 'SET_CLEAR_SEARCH_REFINERS';
export const RECENTLY_VIEWED_HAS_DATA = 'RECENTLY_VIEWED_HAS_DATA';
export const GET_ALL_DATA_DPF_REQUESTS = 'GET_ALL_DATA_DPF_REQUESTS';
export const GET_ALL_DATA_DPF_REQUESTS_METADATA = 'GET_ALL_DATA_DPF_REQUESTS_METADATA';
export const RESET_DPF_REQUESTS = 'RESET_DPF_REQUESTS';
export const SHOW_API_ERROR = 'SHOW_API_ERROR';
export const CLEAR_API_ERROR = 'CLEAR_API_ERROR';
export const SET_API_ERROR_MSG_CONFIG = 'SET_API_ERROR_MSG_CONFIG';
export const STACK_SEARCH_SUGGESTIONS = 'STACK_SEARCH_SUGGESTIONS';
export const PEOPLE_SEARCH_SUGGESTIONS = 'PEOPLE_SEARCH_SUGGESTIONS';
export const CLEAR_PEOPLE_SEARCH_SUGGESTIONS = 'CLEAR_PEOPLE_SEARCH_SUGGESTIONS';

export const FETCH_GOVERNOR_DATA_PRODUCTS = 'FETCH_GOVERNOR_DATA_PRODUCTS';
export const APPEND_GOVERNOR_DATA_PRODUCTS = 'APPEND_GOVERNOR_DATA_PRODUCTS';
export const FETCH_GOVERNOR_DATA_PRODUCTS_REQUEST = 'FETCH_GOVERNOR_DATA_PRODUCTS_REQUEST';
export const APPEND_GOVERNOR_DATA_PRODUCTS_REQUEST = 'APPEND_GOVERNOR_DATA_PRODUCTS_REQUEST';
export const RESET_GOVERNOR_DATA = 'RESET_GOVERNOR_DATA';
export const SET_GOVERNOR_DATA_PRODUCTS_LOADING = 'SET_GOVERNOR_DATA_PRODUCTS_LOADING';

export const FETCH_PRODUCER_DATA_PRODUCTS = 'FETCH_PRODUCER_DATA_PRODUCTS';
export const APPEND_PRODUCER_DATA_PRODUCTS = 'APPEND_PRODUCER_DATA_PRODUCTS';
export const FETCH_PRODUCER_DATA_PRODUCTS_REQUEST = 'FETCH_PRODUCER_DATA_PRODUCTS_REQUEST';
export const APPEND_PRODUCER_DATA_PRODUCTS_REQUEST = 'APPEND_PRODUCER_DATA_PRODUCTS_REQUEST';
export const SET_PRODUCER_DATA_PRODUCTS_LOADING= 'SET_PRODUCER_DATA_PRODUCTS_LOADING';
export const RESET_PRODUCER_DATA = 'RESET_PRODUCER_DATA';

export const FETCH_PRODUCT_REQUEST_DETAILS = 'FETCH_PRODUCT_REQUEST_DETAILS';
export const RESET_PRODUCT_REQUEST_DETAILS = 'RESET_PRODUCT_REQUEST_DETAILS';
export const APPROVE_REJECT_DATA_PRODUCT_REQUEST = 'APPROVE_REJECT_DATA_PRODUCT_REQUEST';

export const CONSUMER_DATA_PRODUCT_REQUESTS = 'CONSUMER_DATA_PRODUCT_REQUESTS';
export const CONSUMER_DATA_PRODUCT_REQUEST_LOADER = 'CONSUMER_DATA_PRODUCT_REQUEST_LOADER';
export const RESET_CONSUMER_DATA_PRODUCT_REQUESTS = 'RESET_CONSUMER_DATA_PRODUCT_REQUESTS';

export const SET_DATA_PRODUCT_FIELD = 'SET_DATA_PRODUCT_FIELD';
export const SET_DATA_PRODUCT_FIELD_ERROR = 'SET_DATA_PRODUCT_FIELD_ERROR';
export const SET_DATA_PRODUCT_LOADER='SET_DATA_PRODUCT_LOADER';
export const CREATE_DATA_PRODUCT = 'CREATE_DATA_PRODUCT';
export const UPDATE_DATA_PRODUCT = 'UPDATE_DATA_PRODUCT';
export const GET_DATA_PRODUCT = 'GET_DATA_PRODUCT';
export const RESET_DATA_PRODUCT = 'RESET_DATA_PRODUCT';
